// extracted by mini-css-extract-plugin
export default {"header":"collapsible-form-block_header__CPNty","wrapper":"collapsible-form-block_wrapper__Haaul"};